import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { RetirementModels } from './RetirementModels';
import type { APIResponse } from '../../../Shared/shared';

export const addRetirement = createAsyncThunk(
  'Retirement/addRetirement',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/AddFaRetirementTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateRetirement = createAsyncThunk(
  'Retirement/updateRetirement',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/UpdateFaRetirementTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getRetirementList = createAsyncThunk(
  'Retirement/getRetirementList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<RetirementModels[]>>(
        'FATransaction/GetRetirementList'
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getRetirementById = createAsyncThunk(
  'Retirement/getRetirementById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<RetirementModels>>(
        `FATransaction/GetRetirementById?Id=${id}`
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

 

const initialState: {
  RetirementList: RetirementModels[];
  RetirementById: RetirementModels;
  // RevaluationByAssetId: RevaluationModels;
  loading: boolean;
  error: any | null;
} = {
  RetirementList: [],
  RetirementById: {} as RetirementModels,
  // RevaluationByAssetId: {} as RevaluationModels,
  loading: false,
  error: null
};

const RetirementSlice = createSlice({
  name: 'Retirement',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getRetirementList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getRetirementList.fulfilled,
        (state, action: PayloadAction<RetirementModels[]>) => {
          state.loading = false;
          state.RetirementList = action.payload;
        }
      )
      .addCase(getRetirementList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      ////////////////////////////////////////////////////////////////
      .addCase(getRetirementById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRetirementById.fulfilled, (state, action: PayloadAction<RetirementModels>) => {
        state.loading = false;
        state.RetirementById = action.payload;
      })
      .addCase(getRetirementById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(getDepreciationByAssetId.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getDepreciationByAssetId.fulfilled, (state, action: PayloadAction<DepreciationModels>) => {
    //   state.loading = false;
    //   state.DepreciationByAssetId = action.payload;
    // })
    // .addCase(getDepreciationByAssetId.rejected, (state, action: PayloadAction<any>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // })
  }
});

export default RetirementSlice.reducer;
